// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL } from "../../store/api";
import { AuthorizationResponse } from "./types";

import * as userActions from "./authorization.actions";

import { ParsedPermission, PermissionDefault, UserRole } from "../../interfaces/UserRole";

const parseRole = (role: UserRole | null) => {
  const permissions = [...PermissionDefault];
  const parsedPermissions: ParsedPermission = {};
  const mutableRole: UserRole | null = role ? {...role} : null;

  if (mutableRole) {
    mutableRole.PERMISSION_DETAIL.forEach(item => {
      const permissionIndex = permissions.findIndex(searchItem => searchItem.MENU_NAME === item.MENU_NAME);
      if (permissionIndex >= 0) {
        permissions[permissionIndex] = item;
      }
    });
    mutableRole.PERMISSION_DETAIL = permissions;

    mutableRole.PERMISSION_DETAIL.map(item => {
      parsedPermissions[item.MENU_NAME] = {...item};
      return null;
    });
  }

  return {...parsedPermissions};
}

export function* getUser(
  action: ReturnType<typeof userActions.getUserAsync.request>
) {
  try {
    const token: string = `${action.payload.authToken}:`;
    const url = BASE_URL + 'detail/user';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: AuthorizationResponse = yield call(result.json.bind(result));
      const systemAccess = parseRole(parsed.data.ROLE_DETAIL);
      
      if (parsed.data.STATUS === 0) {
        const parsed: ErrorResponse = {
          name: 'Akun tidak memiliki akses.',
          message: 'Akses akun telah dicabut dan tidak memiliki akses.',
          code: 500,
          status: 500
        };
        yield put(userActions.getUserAsync.failure(parsed));
        return;  
      }

      yield put(userActions.getUserAsync.success({ response: parsed, systemAccess, token }));
      return; 
    } else {
      const parsed: ErrorResponse = {
        name: 'Internal server error',
        message: 'Internal server error',
        code: 500,
        status: 500
      };
      yield put(userActions.getUserAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }

    if (typeof err === 'string') {
      parsed.message = 'Terjadi kesalahan pada server. Sistem tidak dapat mengambil data pada basis data sistem kerjasama UMN.';
    } else {
      
    }

    yield put(userActions.getUserAsync.failure(parsed));
  }
}

export default function* authorizationSagaGetUser() {
  yield takeEvery(userActions.getUserAsync.request, getUser);
}
